import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { DashboardOverview } from "@/types/dashboard";
import { monthLabel } from "../labels";

export default function ActivityChart({ data }: { data: DashboardOverview["monthlyActivity"] }) {
  const rows = data.map((r) => ({
    mes: monthLabel(r.month),
    Cadastros: r.treesRegistered,
    Vistorias: r.inspectionsDone,
  }));
  const hasActivity = rows.some((r) => r.Cadastros > 0 || r.Vistorias > 0);

  return (
    <section className="bg-white rounded-card border border-background-200 p-5 md:p-6">
      <div className="mb-4">
        <h3 className="text-base font-semibold text-foreground-900 font-heading">Atividade nos últimos 12 meses</h3>
        <p className="text-xs text-foreground-500 mt-0.5">Exemplares cadastrados e vistorias realizadas por mês</p>
      </div>
      {!hasActivity ? (
        <p className="text-sm text-foreground-500 py-10 text-center">Sem atividade registrada no período.</p>
      ) : (
        <div className="h-[230px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 4, right: 8, left: -12, bottom: 0 }} barGap={2}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E8EAED" vertical={false} />
              <XAxis dataKey="mes" tick={{ fontSize: 11, fill: "#6B737A" }} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#6B737A" }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #E8EAED", fontSize: 12 }} cursor={{ fill: "#F5F7F6" }} />
              <Legend iconType="circle" iconSize={8} formatter={(v: string) => <span className="text-xs text-foreground-600">{v}</span>} />
              <Bar dataKey="Cadastros" fill="#1B6E4F" radius={[3, 3, 0, 0]} maxBarSize={18} />
              <Bar dataKey="Vistorias" fill="#0052CC" radius={[3, 3, 0, 0]} maxBarSize={18} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </section>
  );
}
